// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images/aboutushero.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.aboutus__heroimage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100%;
  background-position-y: 1rem;
  width: 100%;
  aspect-ratio: 16/9;
}
@media (min-width: 768px) {
  .aboutus__heroimage {
    max-height: 400px;
    background-position-y: -2rem;
  }
}
@media (min-width: 840px) {
  .aboutus__heroimage {
    background-position-x: center;
    margin-top: 2.5rem;
  }
}
@media (min-width: 900px) {
  .aboutus__heroimage {
    background-position-y: -4rem;
    background-position-x: center;
  }
}
@media (min-width: 1020px) {
  .aboutus__heroimage {
    background-position-y: -6rem;
    background-position-x: center;
  }
}
@media (min-width: 1120px) {
  .aboutus__heroimage {
    background-position-y: -4rem;
    background-size: 90%;
    background-position-x: center;
  }
}
@media (min-width: 1200px) {
  .aboutus__heroimage {
    background-position-y: -6rem;
    background-size: 90%;
    background-position-x: center;
  }
}
@media (min-width: 1280px) {
  .aboutus__heroimage {
    max-height: 500px;
  }
}
.aboutus__title {
  text-align: center;
  font-size: 2rem;
  color: white;
  text-shadow: 2px 2px 4px black;
  margin-top: -7rem;
  font-weight: 400;
  font-size: 2rem;
  padding: 1rem 0;
}
@media (min-width: 440px) {
  .aboutus__title {
    margin-top: -10rem;
    font-size: 2.5rem;
  }
}
@media (min-width: 580px) {
  .aboutus__title {
    margin-top: -12rem;
    font-size: 2.5rem;
    padding-bottom: 4rem;
  }
}
@media (min-width: 768px) {
  .aboutus__title {
    font-size: 2rem;
    color: white;
    text-shadow: 2px 2px 4px black;
    margin-top: -20rem;
  }
}
@media (min-width: 1280px) {
  .aboutus__title {
    margin-top: -25rem;
    font-size: 3rem;
  }
}
.aboutus__heading1, .aboutus__heading2, .aboutus__heading3, .aboutus__headingfinal {
  padding-top: 1rem;
  text-align: center;
  font-weight: 400;
  font-size: 1.3rem;
  padding-left: 1rem;
}
.aboutus__heading1 {
  padding-top: 6rem;
}
@media (min-width: 768px) {
  .aboutus__heading1 {
    padding-top: 1rem;
    font-size: 1.6rem;
    color: white;
    text-shadow: 2px 2px 4px black;
  }
}
@media (min-width: 1280px) {
  .aboutus__heading1 {
    font-size: 2rem;
  }
}
@media (min-width: 768px) {
  .aboutus__heading3, .aboutus__heading2 {
    padding-top: 3rem;
  }
}
@media (min-width: 1280px) {
  .aboutus__heading3, .aboutus__heading2 {
    font-size: 1.8rem;
  }
}
.aboutus__headingfinal {
  padding-top: 4rem;
  padding-bottom: 1rem;
  color: white;
}
@media (min-width: 768px) {
  .aboutus__headingfinal {
    padding-top: 3rem;
    font-size: 1.9rem;
  }
}
@media (min-width: 1280px) {
  .aboutus__headingfinal {
    font-size: 2.5rem;
    padding-top: 4rem;
  }
}
.aboutus__subheadingfinal {
  padding: 0 1rem 1rem 1rem;
  text-align: center;
  line-height: 2rem;
  color: white;
}
@media (min-width: 768px) {
  .aboutus__subheadingfinal {
    font-size: 1.6rem;
    padding-top: 2rem;
    padding-bottom: 3rem;
  }
}
@media (min-width: 1280px) {
  .aboutus__subheadingfinal {
    font-size: 2rem;
    font-weight: 400;
  }
}
.aboutus__image--ourteam {
  display: block;
  margin: auto;
  margin-top: 1rem;
  width: 90%;
  border-radius: 4px;
  max-width: 500px;
}
.aboutus__image--whyhireus {
  display: block;
  margin: auto;
  margin-top: 1rem;
  width: 90%;
  border-radius: 4px;
  max-width: 500px;
}
.aboutus__subcontent1 {
  text-align: center;
  padding: 1rem 1rem 0 1rem;
  max-width: 650px;
  margin: auto;
}
@media (min-width: 768px) {
  .aboutus__subcontent1 {
    color: white;
    font-size: 1.3rem;
    padding: 1rem 3rem;
    text-shadow: 2px 2px 4px black;
  }
}
@media (min-width: 1280px) {
  .aboutus__subcontent1 {
    font-size: 1.8rem;
  }
}
.aboutus__subcontent2 {
  padding: 1rem 1rem 0 1rem;
  text-align: left;
  padding-top: 1rem;
  max-width: 650px;
  margin: auto;
}
@media (min-width: 768px) {
  .aboutus__subcontent2 {
    margin-top: 7rem;
    font-size: 1.1rem;
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1280px) {
  .aboutus__subcontent2 {
    max-width: 950px;
    line-height: 2rem;
  }
}
.aboutus__subcontent3 {
  padding: 1rem 1rem 0 1rem;
  text-align: center;
  max-width: 650px;
  margin: auto;
}
@media (min-width: 768px) {
  .aboutus__subcontent3 {
    margin-top: 2rem;
    font-size: 1.1rem;
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1280px) {
  .aboutus__subcontent3 {
    max-width: 950px;
    line-height: 2rem;
  }
}
.aboutus__subcontent4 {
  text-align: left;
  padding: 2rem 1rem;
  max-width: 650px;
  margin: auto;
}
@media (min-width: 768px) {
  .aboutus__subcontent4 {
    margin-top: 2rem;
    font-size: 1.1rem;
    padding-right: 0;
    padding-left: 0;
    padding-bottom: 3rem;
  }
}
@media (min-width: 1280px) {
  .aboutus__subcontent4 {
    max-width: 950px;
    line-height: 2rem;
  }
}
.aboutus__button {
  font-family: Nexa;
  border-radius: 6px;
  height: 5vh;
  width: 80%;
  display: block;
  margin: auto;
  border: 1px solid rgb(181, 144, 88);
  background-color: rgb(181, 144, 88);
  color: white;
  font-weight: 400;
  font-size: 1.2rem;
}
@media (min-width: 768px) {
  .aboutus__button {
    height: 7vh;
    width: 45%;
  }
}
@media (min-width: 1280px) {
  .aboutus__button {
    font-size: 1.9rem;
    font-weight: 600;
    height: 8vh;
  }
}
.aboutus__contactwrapper {
  margin: auto;
  width: 85%;
  border-radius: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  padding-bottom: 4rem;
  margin-bottom: 1rem;
}
@media (min-width: 768px) {
  .aboutus__contactwrapper {
    height: 20rem;
    margin-bottom: rem;
    max-width: 650px;
    margin-bottom: 3rem;
  }
}
@media (min-width: 1280px) {
  .aboutus__contactwrapper {
    max-width: 850px;
    height: 25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/pages/AboutUsPage/AboutUsPage.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAjFI;EACI,0DAAA;EACA,4BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;AAoFR;AE9FI;EFGA;IASQ,iBAAA;IACA,4BAAA;EAsFV;AACF;AArFQ;EAZJ;IAaQ,6BAAA;IACA,kBAAA;EAwFV;AACF;AAvFQ;EAhBJ;IAiBQ,4BAAA;IACA,6BAAA;EA0FV;AACF;AAzFQ;EApBJ;IAqBQ,4BAAA;IACA,6BAAA;EA4FV;AACF;AA3FQ;EAxBJ;IAyBQ,4BAAA;IACA,oBAAA;IACA,6BAAA;EA8FV;AACF;AA7FQ;EA7BJ;IA8BQ,4BAAA;IACA,oBAAA;IACA,6BAAA;EAgGV;AACF;AE/HI;EFFA;IAmCQ,iBAAA;EAkGV;AACF;AAhGI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAkGR;AAjGQ;EATJ;IAUQ,kBAAA;IACA,iBAAA;EAoGV;AACF;AAnGQ;EAbJ;IAcQ,kBAAA;IACA,iBAAA;IACA,oBAAA;EAsGV;AACF;AEhKI;EFyCA;IAmBQ,eAAA;IACA,YAAA;IACA,8BAAA;IACA,kBAAA;EAwGV;AACF;AEnKI;EFoCA;IAyBQ,kBAAA;IACA,eAAA;EA0GV;AACF;AAxGI;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA0GR;AAxGI;EACI,iBAAA;AA0GR;AExLI;EF6EA;IAGQ,iBAAA;IACA,iBAAA;IACA,YAAA;IACA,8BAAA;EA4GV;AACF;AE3LI;EFwEA;IASQ,eAAA;EA8GV;AACF;AErMI;EFyFA;IAEQ,iBAAA;EA8GV;AACF;AErMI;EFoFA;IAKQ,iBAAA;EAgHV;AACF;AA9GI;EACI,iBAAA;EACA,oBAAA;EACA,YAAA;AAgHR;AEpNI;EFiGA;IAKQ,iBAAA;IACA,iBAAA;EAkHV;AACF;AErNI;EF4FA;IASQ,iBAAA;IACA,iBAAA;EAoHV;AACF;AAlHI;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAoHR;AEtOI;EF8GA;IAMQ,iBAAA;IACA,iBAAA;IACA,oBAAA;EAsHV;AACF;AExOI;EFyGA;IAWQ,eAAA;IACA,gBAAA;EAwHV;AACF;AArHQ;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AAuHZ;AArHQ;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AAuHZ;AApHI;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;AAsHR;AEzQI;EF+IA;IAMQ,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,8BAAA;EAwHV;AACF;AE5QI;EF0IA;IAYQ,iBAAA;EA0HV;AACF;AAxHI;EACI,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AA0HR;AE7RI;EF8JA;IAOQ,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;EA4HV;AACF;AEhSI;EFyJA;IAaQ,gBAAA;IACA,iBAAA;EA8HV;AACF;AA5HI;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA8HR;AEjTI;EF+KA;IAMQ,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;EAgIV;AACF;AEpTI;EF0KA;IAYQ,gBAAA;IACA,iBAAA;EAkIV;AACF;AAhII;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAkIR;AErUI;EF+LA;IAMQ,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,oBAAA;EAoIV;AACF;AEzUI;EF0LA;IAaQ,gBAAA;IACA,iBAAA;EAsIV;AACF;AApII;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,mCAAA;EACA,mCAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAsIR;AEjWI;EFgNA;IAaQ,WAAA;IACA,UAAA;EAwIV;AACF;AElWI;EF2MA;IAiBQ,iBAAA;IACA,gBAAA;IACA,WAAA;EA0IV;AACF;AAxII;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,0DAAA;EACA,oBAAA;EACA,mBAAA;AA0IR;AEtXI;EFsOA;IAQQ,aAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EA4IV;AACF;AEzXI;EFiOA;IAcQ,gBAAA;IACA,aAAA;EA8IV;AACF","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.aboutus{\n    &__heroimage{\n        background-image: url(\"../../assets/images/aboutushero.jpg\");\n        background-repeat: no-repeat;\n        background-attachment: fixed;\n        background-size: 100%;\n        background-position-y: 1rem;\n        width: 100%;\n        aspect-ratio: 16/9;\n        @include tablet-and-desktop{\n            max-height: 400px;\n            background-position-y: -2rem;\n        }\n        @media (min-width: 840px) {\n            background-position-x: center;\n            margin-top: 2.5rem;       \n        }\n        @media (min-width: 900px) {\n            background-position-y: -4rem;\n            background-position-x: center;  \n        }\n        @media (min-width: 1020px) {\n            background-position-y: -6rem;\n            background-position-x: center;  \n        }\n        @media (min-width: 1120px) {\n            background-position-y: -4rem;\n            background-size: 90%;\n            background-position-x: center;  \n        }\n        @media (min-width: 1200px) {\n            background-position-y: -6rem;\n            background-size: 90%;\n            background-position-x: center;  \n        }\n        @include desktop{\n            max-height: 500px;\n        }\n    }\n    &__title{\n        text-align: center;\n        font-size: 2rem;\n        color: white;\n        text-shadow: 2px 2px 4px black;\n        margin-top: -7rem;\n        font-weight: 400;\n        font-size: 2rem;\n        padding: 1rem 0;\n        @media (min-width: 440px) {\n            margin-top: -10rem;   \n            font-size: 2.5rem;     \n        }\n        @media (min-width: 580px) {\n            margin-top: -12rem;   \n            font-size: 2.5rem;  \n            padding-bottom: 4rem;   \n        }\n        @include tablet-and-desktop{\n            font-size: 2rem;\n            color: white;\n            text-shadow: 2px 2px 4px black;\n            margin-top: -20rem;\n        }\n        @include desktop{\n            margin-top: -25rem;\n            font-size: 3rem;\n        }\n    }\n    &__heading1, &__heading2, &__heading3, &__headingfinal{\n        padding-top: 1rem;\n        text-align: center;\n        font-weight: 400;\n        font-size: 1.3rem;\n        padding-left: 1rem;\n    }\n    &__heading1{\n        padding-top: 6rem;\n        @include tablet-and-desktop{\n            padding-top: 1rem;\n            font-size: 1.6rem;\n            color: white;\n            text-shadow: 2px 2px 4px black;\n        }\n        @include desktop{\n            font-size: 2rem;\n        }\n    }\n    &__heading3, &__heading2{\n        @include tablet-and-desktop{\n            padding-top: 3rem;\n        }\n        @include desktop{\n            font-size: 1.8rem;\n        }\n    }\n    &__headingfinal{\n        padding-top: 4rem;\n        padding-bottom: 1rem;\n        color: white;\n        @include tablet-and-desktop{\n            padding-top: 3rem;\n            font-size: 1.9rem;\n        }\n        @include desktop{\n            font-size: 2.5rem;\n            padding-top: 4rem;\n        }\n    }\n    &__subheadingfinal{\n        padding: 0 1rem 1rem 1rem;\n        text-align: center;\n        line-height: 2rem;\n        color: white;\n        @include tablet-and-desktop{\n            font-size: 1.6rem;\n            padding-top: 2rem;\n            padding-bottom: 3rem;\n        }\n        @include desktop{\n            font-size: 2rem;\n            font-weight: 400;\n        }\n    }\n    &__image{\n        &--ourteam{\n            display: block;\n            margin: auto;\n            margin-top: 1rem;\n            width: 90%;\n            border-radius: 4px;\n            max-width: 500px;\n        }\n        &--whyhireus{\n            display: block;\n            margin: auto;\n            margin-top: 1rem;\n            width: 90%;\n            border-radius: 4px;\n            max-width: 500px;\n        }\n    }\n    &__subcontent1{\n        text-align: center;\n        padding: 1rem 1rem 0 1rem;\n        max-width: 650px;\n        margin: auto;\n        @include tablet-and-desktop{\n            color: white;\n            font-size: 1.3rem;\n            padding: 1rem 3rem;\n            text-shadow: 2px 2px 4px black;\n        }\n        @include desktop{\n            font-size: 1.8rem;\n        }\n    }\n    &__subcontent2{\n        padding: 1rem 1rem 0 1rem;\n        text-align: left;\n        padding-top: 1rem;\n        max-width: 650px;\n        margin: auto;\n        @include tablet-and-desktop{\n            margin-top: 7rem;\n            font-size: 1.1rem;\n            padding-right: 0;\n            padding-left: 0;\n        }\n        @include desktop{\n            max-width: 950px;\n            line-height: 2rem;\n        }\n    }\n    &__subcontent3{\n        padding: 1rem 1rem 0 1rem;\n        text-align: center;\n        max-width: 650px;\n        margin: auto;\n        @include tablet-and-desktop{\n            margin-top: 2rem;\n            font-size: 1.1rem;\n            padding-right: 0;\n            padding-left: 0;\n        }\n        @include desktop{\n            max-width: 950px;\n            line-height: 2rem;\n        }\n    }\n    &__subcontent4{\n        text-align: left;\n        padding: 2rem 1rem;\n        max-width: 650px;\n        margin: auto;\n        @include tablet-and-desktop{\n            margin-top: 2rem;\n            font-size: 1.1rem;\n            padding-right: 0;\n            padding-left: 0;\n            padding-bottom: 3rem;\n        }\n        @include desktop{\n            max-width: 950px;\n            line-height: 2rem;\n        }\n    }\n    &__button{\n        font-family: Nexa;\n        border-radius: 6px;\n        height: 5vh;\n        width: 80%;\n        display: block;\n        margin: auto;\n        border: 1px solid rgb(181, 144, 88);\n        background-color: rgb(181, 144, 88);\n        color: white;\n        font-weight: 400;\n        font-size: 1.2rem;\n        @include tablet-and-desktop{\n            height: 7vh;\n            width: 45%;\n        }\n        @include desktop{\n            font-size: 1.9rem;\n            font-weight: 600;\n            height: 8vh;\n        }\n    }\n    &__contactwrapper{\n        margin: auto;\n        width: 85%;\n        border-radius: 6px;\n        background-image: url('../../assets/images/background.jpg');\n        padding-bottom: 4rem;\n        margin-bottom: 1rem;\n        @include tablet-and-desktop{\n            height: 20rem;\n            margin-bottom: rem;\n            max-width: 650px;\n            margin-bottom: 3rem;\n        }\n        @include desktop{\n            max-width: 850px;\n            height: 25rem;\n        }\n    }\n    \n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
